import React from 'react'
import { connect } from 'react-redux'
import { Card, Col, Row } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';

export const Profile = (props) => {
    let color ='green'
    let {
       admission_no,
       surname,
       firstname,
       middlename,
       gender,
       dob,
       soo,
       lga,
       nationality,
       admit,
       photo,
       abbrv,
       cclass,
       g1_address,
       g1_email,
       g1_phone1,
       g1_phone2,
       g1_name,
       g1_rel,
       g2_address,
       g2_email,
       g2_phone1,
       g2_phone2,
       g2_name,
       g2_rel
      } = props.data || ''

      let matriculation_number = abbrv+"/"+admit+"/"+admission_no
      let fullname = surname+" "+firstname+" "+middlename
      let birth_date = moment(dob).format('Do MM YYYY')
      let age = dob
      
    return (
        <>
        <PageHeader
                title="Profile"
                className="site-page-header no-print"
                subTitle="My Data"
                extra={[]}
                avatar={{ src: process.env.PUBLIC_URL+'/asset/icons/admission.png' }}    
            ></PageHeader>
        <Card>
        <Card type="inner" >
            <Row span={24} className="d-flex justify-content-center" >
                <Col 
                    span={24}     
                    className="d-flex justify-content-center"
                    style ={{marginBlock:'auto', width:'100%'}}>
                  <img 
                    height='100px'
                    alt="passport" 
                    src={process.env.REACT_APP_SERVER_URL+ photo} 
                    onError={(e)=>{
                    e.target.onerror=null; 
                    e.target.src=process.env.PUBLIC_URL+'/asset/img/defaultlogo.png'
                  } }
                  />
                </Col>
            </Row>
            <hr style={{color:color}}/>
            <Row>
                <Col xs={24} sm={12} span={8}  className="profile_item">Matriculation Number</Col>
                <Col xs={24} sm={12} span={16} className="profile_data" ><strong style={{fontFamily:'Quicksand'}}>{matriculation_number}</strong></Col>
            </Row>
            <hr/>
            <Row>
                <Col xs={24} sm={12} span={4}  className="profile_item">Fullname</Col>
                <Col xs={24} sm={12} span={20} className="profile_data" ><strong style={{fontFamily:'Quicksand'}}>{fullname}</strong></Col>
            </Row>
            <hr/>
            <Row>
                <Col xs={24} sm={12} span={4}  className="profile_item">Gender</Col>
                <Col xs={24} sm={12} span={20} className="profile_data" ><strong style={{fontFamily:'Quicksand'}}>{gender}</strong></Col>
            </Row>
            <hr/>
            <Row>
                <Col xs={24} sm={12} span={4}  className="profile_item">Date of Birth</Col>
                <Col xs={24} sm={12} span={20} className="profile_data" ><strong style={{fontFamily:'Quicksand'}}>{`${birth_date} ${age}`}</strong></Col>
            </Row>
            <hr/>
            <Row>
                <Col xs={24} sm={12} span={4}  className="profile_item">Bio.</Col>
                <Col xs={24} sm={12} span={20} className="profile_data" ><strong style={{fontFamily:'Quicksand'}}>{`${lga} ${soo} ${nationality}`}</strong></Col>
            </Row>
            <hr/>
            <Row>
                <Col xs={24} sm={12} span={4}  className="profile_item">Date Admitted</Col>
                <Col xs={24} sm={12} span={20} className="profile_data" ><strong style={{fontFamily:'Quicksand'}}>{`${admit} ${cclass}`}</strong></Col>
            </Row>
            <hr/>
            <Row>
                <Col xs={24} sm={12} span={4}  className="profile_item">Primary Contact</Col>
                <Col xs={24} sm={12} span={20} className="profile_data" ><strong style={{fontFamily:'Quicksand'}}>
                    <b>{`${g1_name} (${g1_rel}) `}</b>
                    <i>{g1_address}</i>
                    {`${g1_phone1} ${g1_phone2} ${g1_email} `}
                    </strong>
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col span={4}  className="profile_item">Secondary Contact</Col>
                <Col span={20} className="profile_data" ><strong style={{fontFamily:'Quicksand'}}>
                <b>{`${g2_name} (${g2_rel}) `}</b>
                    <i>{g2_address}</i>
                    {` ${g2_phone1} ${g2_phone2} ${g2_email} `}
                    </strong>
                    </Col>
            </Row>
            <hr/>
            
        </Card>
    </Card>
    </>
    )
}

const mapStateToProps = (state) => ({
    
})

const mapDispatchToProps = {
    
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile)
